import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UtilsService } from '../../shared/utils.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ToastComponent implements OnInit {
  constructor(public utils: UtilsService) {}

  ngOnInit() {}
}
